import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { getAcquirerAccessList, getHeaderDataButtons } from './configStructure.js';
import './CaseLandingGetNextHeader.scss';
import DropDownList from 'Components/DropDownList/DropDownList';
import { getBaseQueueGroupList, getSubQueueGroupList } from 'Apis/queueManagerApi.js';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import { loadState } from '../../../app/src/store/browserStorage.js';
import ResponseBanner from 'Components/cards/ResponseBanner';
import ImagePortal from 'Containers/ImagePortal';
import { getNextCasesOfSubQueue } from '../../../app/src/api/queueManagerApi.js';
import { getUrlSearchParamValue } from 'Utils/urlUtils';
import { removeLockedCases } from 'Utils/localStorageUtils.js';
import { removeCaseFromRecent } from 'Actions/recentCasesAction.js';
import { setActiveStageIndicatorSettingsOpenFlag } from 'Actions/drawerAction';
import SelectInput from 'Components/forms/select-input';
import { unloadCaseAsActive, unloadCaseInfo } from '../../../app/src/actions/caseActions.js';
import SettingsIcon from '../icons/SettingsIcon/SettingsIcon.jsx';
import SettingIcon from '../icons/SettingIcon/SettingIcon.jsx';
import CloseSettingIcon from '../icons/CloseSettingIcon/CloseSettingIcon.jsx';

export class CaseLandingGetNextHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      regionDataList: [],
      buttonAnalyst: true,
      buttonInternal: false,
      buttonMerchant: false,
      queueSummaryCount: [],
      totalQueueCount: [],
      internalEmployees: ['DiMS_INTERNAL_EMPLOYEE'],
      isLoading: false,
      dropDownBaseQueues: [],
      dropDownSubQueues: [{ focus: true }],
      selectedBaseQueueItem: {},
      selectedSubQueueItem: {},
      acquirerAccessList: [],
      isActiveStageIndicatorEnabled: false,
      getNextDisable: false
    };
    this.attachBindings();
  }

  attachBindings() {
    this.handleSelectionBaseQueue = this.handleSelectionBaseQueue.bind(this);
    this.handleSelectionSubQueue = this.handleSelectionSubQueue.bind(this);
    this.getBaseQueueGroupList = this.getBaseQueueGroupList.bind(this);
    this.getSubQueueGroupList = this.getSubQueueGroupList.bind(this);
    this.getNextClickHandler = this.getNextClickHandler.bind(this);
    this.showBanner = this.showBanner.bind(this);
    this.goToDashBoard = this.goToDashBoard.bind(this)
    this.gotoCaseLandingPage = this.gotoCaseLandingPage.bind(this);
  }

  componentWillMount() {
    const auth = loadState('auth');
    const userPermission = JSON.parse(sessionStorage.getItem('state')).auth.user.parsedPermissions.queue;
    this.setState({
      canView: userPermission.canViewAll,
      getNextCase: userPermission.getNextCaseInQueue,
    });
  }


  componentDidMount() {
    let acquirerAccessList = getAcquirerAccessList();
    this.setState({
      acquirerAccessList: acquirerAccessList,
      caseNumber: this.props.location.pathname.split("/")[2],
    })
    this.getBaseQueueGroupList(acquirerAccessList), this.getSubQueueGroupList();
    if (this.state.internalEmployees.findIndex(internalEmp => internalEmp == this.state.role) != -1) {
      this.setState({
        isInternalEmployee: true
      })
    }
  }
  componentWillUpdate(nextProps, nextState) {
    const isGetNextDisabled = !nextState.getNextCase || nextState.selectedSubQueueItem.text == 'Select Queue' || this.props.getNextDisable || nextState.getNextDisable;
    if (!isGetNextDisabled && nextProps.isReadOnly) {
      if (this.state.selectedSubQueueItem?.id !== nextState.selectedSubQueueItem?.id) {
        this.setState({ selectedSubQueueItem: nextState.selectedSubQueueItem }, () => {
          this.getNextClickHandler();
        })
      }
    }
  }

  handleSelectionBaseQueue(selectedItem) {
    this.setState({ selectedBaseQueueItem: selectedItem, selectedSubQueueItem: { text: 'Select Queue', value: "" } }, () => this.getSubQueueGroupList());
    let caseNumber = this.props.location.pathname.split("/")[2];
    let subQueueSelection = "";
    let baseQueueSelection = selectedItem.text;
    this.props.history.push(`/caselanding/${caseNumber}?selectedBaseQueueItem=${baseQueueSelection}&subQueueSelection=${subQueueSelection}`);
  }

  handleSelectionSubQueue(selectedItem) {
    this.setState({ selectedSubQueueItem: selectedItem, getNextDisable: false });
    let caseNumber = this.props.location.pathname.split("/")[2];
    let subQueueSelection = selectedItem.text;
    let baseQueueSelection = this.state.selectedBaseQueueItem.text;
    this.props.history.push(`/caselanding/${caseNumber}?selectedBaseQueueItem=${baseQueueSelection}&subQueueSelection=${subQueueSelection}`);
  }

  openDrawer = (id) => {
    // Card brand data(id = 2), case data(id = 1), Auth data(id = 3), and Tran data(id = 4)
    if (id == 1 || id == 2) {
      this.props.getApiDrawerData(
        this.props.caseLandingHistory ? this.props.caseLandingHistory[0].caseStageId : null,
        id,
        null,
        true,
      );
    } else
      this.props.getApiDrawerData(
        id == 3
          ? (this.props.caseLandingData.authorizationDetail_authorizationMasterId ? this.props.caseLandingData.authorizationDetail_authorizationMasterId : this.props.caseLandingData.authorizationDetail?.authorizationMasterId)
          : (this.props.caseLandingData.transactionDetail_transactionMasterId ? this.props.caseLandingData.transactionDetail_transactionMasterId : this.props.caseLandingData.transactionDetail?.transactionMasterId),
        id,
        this.props.caseLandingHistory ? this.props.caseLandingHistory[0].caseStageId : null,
      );
    this.props.toggleDrawer(true, id);
  };

  formatObject = (item) => {
    return {
      focus: item.focus,
      id: item.customQueueId,
      value: item.subCategoryCode,
      text: item.baseQueueLabel,
      queueGroupCode: item.queueGroupCode,
    }
  }

  getBaseQueueGroupList(acquirerAccessList) {
    const baseQueueSelectionText = getUrlSearchParamValue(this.props.location.search, 'selectedBaseQueueItem');
    let baseQueue = [];
    getBaseQueueGroupList(acquirerAccessList).then((apiResponse) => {
      let alreadySelected = apiResponse.data.filter((item) => item.baseQueueLabel == baseQueueSelectionText)[0];
      let firstItem = this.formatObject(alreadySelected ? alreadySelected : { focus: true, customQueueId: "SQ", baseQueueLabel: 'Select Queue', subCategoryCode: null });
      apiResponse.data.map((item,) => { baseQueue.push(this.formatObject(item)) })
      this.setState({
        dropDownBaseQueues: baseQueue,
        selectedBaseQueueItem: firstItem
      }, () => this.getSubQueueGroupList())
    })
      .catch((error) => {
        console.log('error received while fetching data columns based on queue page', error);
      });
  }

  getSubQueueGroupList() {
    const subQueueSelectionText = getUrlSearchParamValue(this.props.location.search, 'subQueueSelection');
    let selectedItem = this.state.selectedBaseQueueItem.value;
    let subQueues = [];
    if (!selectedItem) {
      this.setState({ selectedSubQueueItem: { focus: true, id: "SQ", text: 'Select Queue', value: "" } })
    }
    if (selectedItem) {
      getSubQueueGroupList(this.state.acquirerAccessList, selectedItem).then(apiResponse => {
        apiResponse?.data.map(item => {
          if (item.queueVisibilityInd) {
            subQueues.push({
              focus: false,
              id: item.customQueueId,
              value: item.queueCategoryCode,
              text: item.queueLabel
            })
          }
        })
        let first = subQueues.filter(item => item.text == subQueueSelectionText)[0];
        let firstSubQueue = first ? first : { focus: true, id: "SQ", text: 'Select Queue', value: "" };
        this.setState({ dropDownSubQueues: subQueues, selectedSubQueueItem: firstSubQueue })
      }).catch((error) => {
        this.setState({ dropDownSubQueues: [] })
        console.log('error received while fetching data columns based on queue page', error);
      });
    }
  }

  gotoCaseLandingPage(caseNumber) {
    let subQueueSelection = this.state.selectedSubQueueItem.text;
    let baseQueueSelection = this.state.selectedBaseQueueItem.text;
    this.props.history.push(`/caselanding/${caseNumber}?selectedBaseQueueItem=${baseQueueSelection}&subQueueSelection=${subQueueSelection}`);
  }

  getNextClickHandler() {
    this.setState({
      getNextDisable: true,
    }, () => {
      let userId = JSON.parse(sessionStorage.getItem('state')).auth.user.userId;
      return getNextCasesOfSubQueue(this.state.selectedSubQueueItem.id, userId, this.props.prevCaseNumber).then((apiResponse) => {
        if (apiResponse.status.statusCode === 2000) {
          this.setState({
            caseNumber: apiResponse.data,
          }, () => {
            this.gotoCaseLandingPage(this.state.caseNumber);
            this.removeFromOpenCases(this.props.prevCaseNumber, this.props.prevCaseStageId);
            this.setState({
              getNextDisable: false,
            })
          });
        }
      }).catch((error) => {
        console.log('error received while fetching next case of subqueue', error);
        if (error.response?.status === 404) {
          this.setState({
            noCaseFound: true,
            isLoading: false
          });
        }
      });
    });
  };


  goToDashBoard() {
    this.removeFromOpenCases(this.props.prevCaseNumber, this.props.prevCaseStageId);
    this.props.history.push({
      pathname: '/dashboard',
    });
  }
  showBanner() {
    return (
      <div>
        {this.state.noCaseFound && (
          <ImagePortal>
            <ResponseBanner
              titleStyle={{ color: 'light-green' }}
              descriptionStyle={{ color: 'grey' }}
              valueStyle={{ color: 'black' }}
              title="No available case is found."
              description=""
              type="warning"
              onClose={this.goToDashBoard}
              successOnly={true}
              primaryButtonText="OKAY"
              primaryButtonAction={this.goToDashBoard}
            />
          </ImagePortal>
        )}
      </div>
    );
  }

  removeFromOpenCases = (prevCaseNumber, prevCaseStageId) => {
    if (this.props.unloadCaseAsActive) {
      this.props.unloadCaseAsActive(Number(prevCaseNumber), Number(prevCaseStageId));
      this.props.unloadCaseInfo(Number(prevCaseNumber));
    }
    else {
      removeLockedCases(prevCaseNumber, prevCaseStageId);
      this.props.removeCaseFromRecent(prevCaseNumber);
    }
  }

  isHeaderButtonDisabled = (buttonName) => {
    if (
      (buttonName === 'Tran Data' && (this.props.caseLandingData.transactionDetail_transactionMasterId ? this.props.caseLandingData.transactionDetail_transactionMasterId === undefined : this.props.caseLandingData.transactionDetail?.transactionMasterId === undefined)) ||
      (buttonName === 'Auth Data' && (this.props.caseLandingData.authorizationDetail_authorizationMasterId ? this.props.caseLandingData.authorizationDetail_authorizationMasterId === undefined : this.props.caseLandingData.authorizationDetail?.authorizationMasterId === undefined))
    )
      return true;
    return false;
  };

  getSettingsIcon = () => {
    return (this.state.isActiveStageIndicatorEnabled || this.props.isActiveStageIndicatorSettingsEnabled) ? (
      <>
        <SettingIcon className="settings-icon" />
        <CloseSettingIcon className="close-setting-icon" />
      </>
    ) : (
      <SettingsIcon className="settings-icon" />
    );
  };


  onActiveStageIndicatorEnableClick = () => {
    const flag = this.state.isActiveStageIndicatorEnabled || this.props.isActiveStageIndicatorSettingsEnabled
    this.props.setActiveStageIndicatorSettingsOpenFlag(!flag)
    this.setState({
      isActiveStageIndicatorEnabled: !flag
    })
  }
  render() {
    {
      this.state.dropDownBaseQueues.length == undefined && <BVLoader20 />
    }
    const headerDataButtons = getHeaderDataButtons();
    const auth = loadState('auth');
    const userPermission = auth.user.parsedPermissions.case;
    return (
      <div className="queue-container">
        {this.showBanner()}
        <div className={this.props.isSearchActive ? 'main-content--header reports-container--header secondary-header getNextHeader' : 'main-content--header'} style={this.props.isSearchActive ? undefined : { zIndex: 1, top: 85, paddingLeft: 0 }}>
          <div className="flex-left" >
            {this.state.dropDownBaseQueues != undefined && this.state.dropDownBaseQueues.length > 0 &&
              <div className="maindivSubQueue">
                <div className="dropdown-viewBase">
                  {
                    this.state.canView &&
                    <DropDownList
                      dropDownList={this.state.dropDownBaseQueues}
                      selectedItemText={this.state.selectedBaseQueueItem.text}
                      selectDropdownItem={this.handleSelectionBaseQueue}
                      extraStyle={{ left: 5, width: 230 }}
                      isFocus={false}
                    />
                  }
                </div>

                {
                  this.state.canView &&
                  <div className="dropdown-viewSub">
                    <DropDownList
                      dropDownList={this.state.dropDownSubQueues}
                      selectedItemText={this.state.selectedSubQueueItem.text}
                      selectDropdownItem={this.handleSelectionSubQueue}
                      extraStyle={{ left: 5, width: 230 }}
                      isFocus={false}
                    />
                  </div>
                }
                {
                  <div className="getnext">
                    <button className="getnext-button" disabled={!this.state.getNextCase || this.state.selectedSubQueueItem.text == 'Select Queue' || this.props.getNextDisable || this.state.getNextDisable} onClick={this.getNextClickHandler}>
                      <div className="getnext-text" > Get Next {' '}<span className='get-next-arrow'><svg width="7" height="12" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.87483 5.32478L1.45058 9.68142C1.27406 9.85794 0.988621 9.85794 0.812102 9.68142L0.545445 9.41477C0.368926 9.23825 0.368926 8.95281 0.545445 8.77629L4.38756 5.00554L0.549201 1.23479C0.372681 1.05827 0.372681 0.772831 0.549201 0.596312L0.815858 0.329655C0.992377 0.153136 1.27781 0.153136 1.45433 0.329655L5.87858 4.6863C6.05135 4.86282 6.05135 5.14826 5.87483 5.32478Z" fill="currentColor" />
                      </svg>
                      </span>
                      </div>
                    </button>
                  </div>
                }

              </div>
            }
          </div>
          <div className="flex-right">
            {!this.props.isMerchantUser &&
              headerDataButtons.map((button, index) => {
                return (
                  <button
                    onClick={() => {
                      this.openDrawer(button.buttonID);
                    }}
                    key={index}
                    id={button.buttonName.split(' ').join('').concat('_Header')}
                    className={
                      this.isHeaderButtonDisabled(button.buttonName)
                        ? 'button-view-case-splitter button-disabled'
                        : 'button-view-case-splitter'
                    }
                    disabled={this.isHeaderButtonDisabled(button.buttonName)}
                  >
                    {button.buttonName}
                  </button>
                );
              })}
            {this.props.isReadOnly === true || this.props.disableTakeAction === true ? (
              <SelectInput wrapperClass="read-only-mode" id="take-action-btn" promptText="Take Action" isReadOnly={true} />
            ) : (
              this.props.selectList &&
              this.props.selectList.length > 0 &&
              this.props.caseLandingData &&
              !this.props.getIsLoadingStatus() &&
              this.props.getTakeActions()
            )}
            {
              userPermission.canAssignCase && (
                <span
                  className={"settings-icon"}
                  onClick={() => this.onActiveStageIndicatorEnableClick()}
                >
                  {this.getSettingsIcon()}
                </span>
              )
            }
          </div>
        </div>
      </div>
    )
  }
}

CaseLandingGetNextHeader.propTypes = {
  unloadCaseAsActive: PropTypes.func
};

CaseLandingGetNextHeader.defaultProps = {
  unloadCaseAsActive: () => { }
};

const mapStateToProps = (state) => ({
  filters: state.searchFilter.filters,
  isSearchActive: state.appSearch.isSearchActive,
  user: state.auth.user,
  isActiveStageIndicatorSettingsEnabled: state.appSearch.isActiveStageIndicatorSettingsEnabled
});

const mapDispatchToProps = (dispatch) => {
  return {
    removeCaseFromRecent: (caseNumberToRemove) => {
      dispatch(removeCaseFromRecent(caseNumberToRemove));
    },
    fetchFilterElements: (searchTypeId) => {
      dispatch(fetchFilterElements(searchTypeId));
    },
    setSearchOpenFlag: (isSearchActive) => {
      dispatch(setSearchOpenFlag(isSearchActive));
    },
    unloadCaseAsActive: (caseNumber, caseStageId) => {
      dispatch(unloadCaseAsActive(caseNumber, caseStageId));
    },
    unloadCaseInfo: (caseNumber) => {
      dispatch(unloadCaseInfo(caseNumber));
    },
    setActiveStageIndicatorSettingsOpenFlag: (isActiveStageIndicatorSettingsEnabled) => {
      dispatch(setActiveStageIndicatorSettingsOpenFlag(isActiveStageIndicatorSettingsEnabled));
    },
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CaseLandingGetNextHeader));
